import orgContainer from '@Components/AppContainer';
import InnerComponent from '@Components/Home/PendingSalesOrders';

const PendingSalesOrders = () => ((orgContainer(InnerComponent)));

export default PendingSalesOrders;
